module.exports = __webpack_public_path__ + "static/img/Dion_Prestia_mobile.43bfc01.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Dion_Prestia_mobile.jpg
// module id = Xt3k
// module chunks = 0